module.exports = __webpack_public_path__ + "img/save.67b6272c.svg";